import { Button } from "@/components/ui/Button";

interface SettingsSaveRowProps {
  canWrite: boolean;
  saving: boolean;
  success: boolean;
  successText: string;
  error: string | null;
  label?: string;
}

/** Statuszeile + Speichern-Button am Ende eines Einstellungs-Abschnitts */
export function SettingsSaveRow({
  canWrite,
  saving,
  success,
  successText,
  error,
  label = "Speichern",
}: SettingsSaveRowProps) {
  return (
    <>
      {error ? <p className="text-sm text-status-red">{error}</p> : null}
      {success ? <p className="text-sm text-status-green">{successText}</p> : null}
      {canWrite ? (
        <div className="flex justify-end">
          <Button type="submit" loading={saving}>
            {label}
          </Button>
        </div>
      ) : null}
    </>
  );
}
